<div class="row">
  <div class="col text-center">
    <div class="card" *ngIf="trialPeriodEnded"> 
      <div class="view gradient-card-header success-gradient white-text">
        <h3 class='h3-responsive text-center text-truncate'>Account Limited - Active Your Subscription Today!</h3>
      </div>
      <div class="card-body">
        <p>Your free subscription trial has now ended and some site functionality has been restricted on your account.
          Add your credit card and upgrade your account to continue services.</p>
        <a [routerLink]="subscriptionSignupRoute" class="btn btn-link btn-primary">Signup for a Subscription Today!</a>

        <p>The billing card on file for your company is no longer valid and we've been unable to collect payment for your subscription.</p>
        <p>Update your billing card and re-activate your account today!</p>
        <div class="alert alert-info">
          <h6>Notice</h6>
          <hr />
          If you do not activate your account by {{terminationDate| date : 'longDate'}} your account
          and patient information will be removed from our system according to our <a [routerLink]="['/terms-and-conditions']">Terms and Conditions</a>.
        </div>
      </div>
    </div>
    
    <div class="card" *ngIf="!trialPeriodEnded">
      <div class="view gradient-card-header success-gradient white-text">
        <h3 class='h3-responsive text-center text-truncate'>Account Limited - Active Your Subscription Today!</h3>
      </div>
      <div class="card-body">
        <p>This functionality is disabled due to restrictions placed upon your account.  To remove these restrictions you must 
          update your billing information with a valid billing
          card or reactivate your monthly subscription.</p>
        <a [routerLink]="['/admin/my-account/billing']" class="btn btn-link btn-primary">Manage Billing Information</a>
        <div class="alert alert-info">
          <h6>Notice</h6>
          <hr />
          If you do not activate your account by {{terminationDate| date : 'longDate'}} your account
          and patient information will be removed from our system according to our <a [routerLink]="['/terms-and-conditions']">Terms and Conditions</a>.
        </div>
      </div>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/admin/user-upgrade-subscription-notice/user-upgrade-subscription-notice.component.html